import { render, staticRenderFns } from "./manage_sharing.vue?vue&type=template&id=df9c2b5c&scoped=true&"
import script from "./manage_sharing.vue?vue&type=script&lang=js&"
export * from "./manage_sharing.vue?vue&type=script&lang=js&"
import style0 from "./manage_sharing.vue?vue&type=style&index=0&id=df9c2b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9c2b5c",
  null
  
)

export default component.exports